import React from "react";
import { Container, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/AboutUsHero.css";

const AboutUsHero = () => {
  const handleGetInTouch = () => {
    // Redirect to LinkedIn profile
    window.open("https://www.linkedin.com/in/m-talha-6b1222251", "_blank");
  };

  return (
    <div className="hero-aboutus-section">
      <Container className="text-white d-flex flex-column align-items-start justify-content-center h-100">
        <p className="small-text">ABOUT US</p>
        <h1 className="aboutus-hero-text">Empowering businesses <br/>  through innovative solutions</h1>
        <Button 
          variant="light" 
          className="mt-3"
          onClick={handleGetInTouch}
        >
          GET IN TOUCH
        </Button>
      </Container>
    </div>
  );
};

export default AboutUsHero;
